<template>
 <router-view></router-view>

</template>

<script>
import 'vue3-toastify/dist/index.css';
export default {
  name: 'App',
  components: {
  }
}
</script>
